import type { ZoneQuotazione } from '@/data/zone-quotazioni'
import { exportFileName, downloadBlob } from './common'

const QUOTAZIONI_COLUMNS = [
  { header: 'Zona', width: 30 },
  { header: 'Abitabile €/mq', width: 16 },
  { header: 'Ristrutturato €/mq', width: 18 },
  { header: 'Da Ristrutt. €/mq', width: 18 },
  { header: 'Posizione %', width: 14 },
  { header: 'Pertinenza %', width: 14 },
  { header: 'Esposizione %', width: 14 },
  { header: 'Spazi Est. %', width: 14 },
  { header: 'No Ascensore %', width: 16 },
  { header: 'Casa (molt.)', width: 14 },
  { header: 'Villa (molt.)', width: 14 },
] as const

function zoneToRow(zone: ZoneQuotazione): string[] {
  const pct = (v: number) => (Math.round(v * 10000) / 100).toString()
  return [
    zone.nome,
    zone.prezzoAbitabile.toString(),
    zone.prezzoRistrutturato.toString(),
    zone.prezzoDaRistrutturare.toString(),
    pct(zone.posizioneBonus),
    pct(zone.pertinenzaBonus),
    pct(zone.esposizioneBonus),
    pct(zone.spaziEsterniBonus),
    pct(zone.senzaAscensore),
    zone.casa.toString(),
    zone.villa.toString(),
  ]
}

export function exportQuotazioniCSV(zones: ZoneQuotazione[]) {
  const headers = QUOTAZIONI_COLUMNS.map(c => c.header)
  const rows = zones.map(zoneToRow)

  const csvContent = [
    headers.join(';'),
    ...rows.map(row => row.join(';')),
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  downloadBlob(blob, exportFileName('quotazioni', 'csv'))
}

export async function exportQuotazioniExcel(zones: ZoneQuotazione[]) {
  const XLSX = await import('xlsx')

  const headers = QUOTAZIONI_COLUMNS.map(c => c.header)
  const rows = zones.map(zoneToRow)

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])
  ws['!cols'] = QUOTAZIONI_COLUMNS.map(c => ({ wch: c.width }))

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Quotazioni')

  XLSX.writeFile(wb, exportFileName('quotazioni', 'xlsx'))
}
